
          export const batfishContext = {
            selectedConfig: {
              siteBasePath: '/ekmap-platform-map-api',
              siteOrigin: 'https://maplibre.github.io',
              hijackLinks: true,
              manageScrollRestoration: true
            },
            routes: [{
            path: '/ekmap-platform-map-api/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/examples/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-examples" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_examples.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/geocode/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-geocode" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_geocode.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/geocode/autocomplete/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-geocode-autocomplete" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_geocode_autocomplete.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/geocode/forward/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-geocode-forward" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_geocode_forward.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/geocode/reverse/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-geocode-reverse" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_geocode_reverse.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/location/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-location" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_location.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/location/administrative/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-location-administrative" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_location_administrative.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/location/distance/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-location-distance" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_location_distance.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/location/elevation/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-location-elevation" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_location_elevation.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/location/highvoltage/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-location-highvoltage" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_location_highvoltage.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/location/hydro/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-location-hydro" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_location_hydro.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/location/industrialzone/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-location-industrialzone" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_location_industrialzone.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/location/landuse/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-location-landuse" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_location_landuse.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/location/landuseplan/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-location-landuseplan" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_location_landuseplan.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/location/population/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-location-population" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_location_population.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/location/protectedareas/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-location-protectedareas" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_location_protectedareas.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/location/railwaycorridor/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-location-railwaycorridor" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_location_railwaycorridor.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/location/soils/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-location-soils" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_location_soils.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/location/zoning/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-location-zoning" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_location_zoning.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/maps-embed-api/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-maps-embed-api" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_maps-embed-api.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/maps/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-maps" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_maps.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/maps/fonts/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-maps-fonts" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_maps_fonts.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/maps/raster-tiles/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-maps-raster-tiles" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_maps_raster-tiles.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/maps/staticmap/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-maps-staticmap" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_maps_staticmap.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/maps/styles/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-maps-styles" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_maps_styles.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/maps/vector-tiles/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-maps-vector-tiles" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_maps_vector-tiles.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/navigation/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-navigation" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_navigation.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/navigation/direction/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-navigation-direction" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_navigation_direction.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/navigation/isochrone/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-navigation-isochrone" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_navigation_isochrone.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/navigation/match/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-navigation-match" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_navigation_match.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/navigation/matrix/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-navigation-matrix" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_navigation_matrix.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/navigation/nearest/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-navigation-nearest" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_navigation_nearest.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/navigation/tsp/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-navigation-tsp" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_navigation_tsp.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/navigation/vrp/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-navigation-vrp" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_navigation_vrp.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/overview/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-overview" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_overview.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/poi/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-poi" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_poi.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/poi/detail/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-poi-detail" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_poi_detail.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-api/poi/search/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-api-poi-search" */
              '/home/toannc/ekmap-platform-map-api/_batfish_tmp/_ekmap-platform-map-api_poi_search.js'
            ),
            
            
          }],
            notFoundRoute: {
      path: '',
      getPage: () => { throw new Error('No matching route.'); },
      is404: true
    }
          };